import request from '../http';

export const listConfigs = (params) =>
  request({ url: '/system/configs', method: 'get', params });

export const createConfig = (data) =>
  request({ url: '/system/configs', method: 'post', data });

export const updateConfig = (id, data) =>
  request({ url: `/system/configs/${id}`, method: 'put', data });

export const deleteConfig = (id) =>
  request({ url: `/system/configs/${id}`, method: 'delete' });

export const getConfigByKey = (key) =>
  request({ url: '/system/configs/by-key', method: 'get', params: { key } });
